<nz-card>
  <div class="row">
    <div class="col-2">
      <div class="btn-updateNAV">
        <button nz-button nzType="primary" style="margin-bottom: 20px;" (click)="openPopupNAV()">Cập nhật NAV</button>
      </div>
    </div>
  </div>
  <nz-divider></nz-divider>
  <nz-table #listViewTable [nzData]="list" [nzShowPagination]="false" [nzFrontPagination]="false">
    <thead>
      <tr>
        <th>Request ID</th>
        <th>Ngày tạo</th>
        <th>Người tạo</th>
        <th>
          <div class="d-flex">
            <span style="width: 100px;">Sản phẩm :</span>
            <span style="width: 150px;">NAV trước</span>
            <span style="width: 150px;">NAV sau</span>
            <span style="width: 150px;">Ngày cập nhật</span>
          </div>
        </th>
        <th>Trạng thái</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of list; trackBy: trackId">
        <td>{{item.navChangeRequestId}}</td>
        <td>{{item.createAt | date: 'dd/MM/yyyy, hh:mm'}}</td>
        <td>{{item.ownerName}}</td>
        <td>
          <div class="d-flex" >
            <div class="d-flex flex-column" style="width: 100px;">
              <span *ngFor="let product of item.productNavInDtoList"
              [style.color]="product.isHighligt ? 'red' : 'black'">{{product.code}} : </span>
            </div>
            <div class="d-flex flex-column"  style="width: 150px;">
              <span *ngFor="let product of item.productNavInDtoList"
              [style.color]="product.isHighligt ? 'red' : 'black'">{{product.currentNav | number}} VND</span>
            </div>
            <div class="d-flex flex-column"  style="width: 150px;">
              <span *ngFor="let product of item.productNavInDtoList"
              [style.color]="product.isHighligt ? 'red' : 'black'">{{product.nav | number}} VND</span>
            </div>
            <div class="d-flex flex-column">
              <span *ngFor="let product of item.productNavInDtoList"
              [style.color]="product.isHighligt ? 'red' : 'black'">{{product.date}}</span>
            </div>
          </div>
        </td>
        <td>{{item?.statusId?.name}}</td>
        <td>
          <div class="d-flex" *userAuthority="['ROLE_ADMIN']">
            <button nz-button nzType="primary" class="btn btn-primary mr-3" (click)="confirmApprove(item)" title="Approve">Approve</button>
            <button nz-button nzType="danger" class="btn btn-danger" (click)="confirmReject(item)" title="Reject">Từ chối</button>
          </div>
        </td>
      </tr>
    </tbody>
  </nz-table>
  <div class="ant-table-pagination ant-pagination">
    <nz-pagination [nzPageIndex]="queryParams.page" [nzTotal]="queryParams.totalItems"
      [nzPageSize]="queryParams.size" [nzShowTotal]="rangeTemplate" (nzPageIndexChange)="loadPage($event)">
    </nz-pagination>
    <ng-template #rangeTemplate let-range="range" let-total>
      {{ range[0] }} - {{ range[1] }} of {{ queryParams.totalItems }} items
    </ng-template>
  </div>
</nz-card>